// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionImage_wrapper__xN3pf","input":"SectionImage_input__daAD-"};